export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
    ],
    code: [
        { required: true, message: 'Пожалуйста, введите код ', trigger: 'blur' },
    ]
};
